import { CSSProperties } from 'react';

/**
 * Mirrors the legacy `.re-typeahead-text` row (`resourcedashboard.html:15-19`): label and select
 * inline on one line, directly under the resource banner.
 *
 * The select is deliberately left unstyled beyond its width. Legacy renders a bare native
 * `<select>` with no class, and the captured prod screen shows exactly that — imposing a border,
 * height or background here would invent tokens the design never had and drift from the platform
 * control users already know. The 20px horizontal padding matches `pageStyles.userBanner`
 * (YearlyCalendarPage.tsx:66) so this row lines up with the banner above it.
 */
export const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 20px 10px 20px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#333333',
  },
  select: {
    minWidth: '175px',
    fontSize: '14px',
  },
};
